import * as Sentry from "@sentry/react-router";
import { HydratedRouter } from "react-router/dom";
import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";

// Get the nonce from the meta tag
const nonce = document
  .querySelector('meta[name="csp-nonce"]')
  ?.getAttribute("content");

if (import.meta.env.VITE_APP_ENV === "prod") {
  Sentry.init({
    dsn: "https://a39ea98500c8710c5896c263280dd310@o4508358142787584.ingest.de.sentry.io/4508358241812560",
    tracesSampleRate: 1,
    integrations: [Sentry.browserTracingIntegration()],
    environment: import.meta.env.VITE_APP_ENV,
  });
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>,
  );
});
